import React from 'react';
import { Elements } from 'prismic-reactjs';
import {
  Link,
  OrderedList,
  OrderedListItem,
  Paragraph,
  Subtitle,
} from '../../styles/pages/styled/document.styles';

const propsWithUniqueKey = (props: object, key: any) =>
  Object.assign(props || {}, { key });

// TODO: type of this function
export const documentHtmlSerializer = (
  type: Elements,
  element: any,
  content: string,
  children: any[],
  key: string
): any => {
  let props = {};

  switch (type) {
    case Elements.paragraph:
      props = {};

      return React.createElement(
        Paragraph,
        propsWithUniqueKey(props, key),
        children
      );

    case Elements.heading2:
      props = {};

      return React.createElement(
        Subtitle,
        propsWithUniqueKey(props, key),
        children
      );

    case Elements.oList:
      props = {};

      return React.createElement(
        OrderedList,
        propsWithUniqueKey(props, key),
        children
      );

    case Elements.oListItem:
      props = {};

      return React.createElement(
        OrderedListItem,
        propsWithUniqueKey(props, key),
        children
      );

    case Elements.hyperlink:
      const targetAttr = element.data.target
        ? { target: element.data.target }
        : {};
      const relAttr = element.data.target ? { rel: 'noreferrer noopener' } : {};

      const href = element.data.url;

      props = Object.assign(
        {
          href,
        },
        targetAttr,
        relAttr
      );

      return React.createElement(
        Link,
        propsWithUniqueKey(props, key),
        children
      );

    default:
      return null;
  }
};
